var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ws-delimiter"},[_c('div',{staticClass:"line",class:_vm.lineClass}),(_vm.text)?_c('div',{staticClass:"text ws-typo-xs",class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")]):_vm._e(),(_vm.text)?_c('div',{staticClass:"line",class:_vm.lineClass}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }